import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import AddCidrButton from './AddCidrButton';
import CidrTable from './CidrTable';
import Text from '../../elements/text/Text';
import TabPanel from '../instance-tabs/TabPanel';

const CidrAddressTab = ({
  instance,
  instanceBusy,
  maxCidrLimit,
  onUpdateCidrs,
}) => {
  const { t } = useTranslation();

  return (
    <TabPanel value={1} index={1}>
      <Text>
        <Trans
          t={t}
          i18nKey="settings.cidrSection"
          ns="descriptions"
          components={[
            <Link
              key="0"
              target="_blank"
              href="https://www.keycdn.com/support/what-is-cidr"
              rel="noreferrer"
              underline="hover"
            />,
          ]}
        />
      </Text>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
        <AddCidrButton
          instance={instance}
          instanceBusy={instanceBusy}
          maxCidrLimit={maxCidrLimit}
          onAddCidr={onUpdateCidrs}
        />
        <CidrTable
          cidrs={instance.cidrs}
          instanceBusy={instanceBusy}
          onRemoveCidr={onUpdateCidrs}
        />
      </Box>
    </TabPanel>
  );
};

CidrAddressTab.propTypes = {
  instance: PropTypes.object.isRequired,
  instanceBusy: PropTypes.bool,
  maxCidrLimit: PropTypes.number.isRequired,
  onUpdateCidrs: PropTypes.func.isRequired,
};

export default CidrAddressTab;
